export const API_NAME = {
  GET_ADS: 'getAds',
  GET_AD_DETAIL: 'getAdDetail',
  GET_ADVERTISERS: 'getAdvertisers',
  GET_ADVERTISER_DETAIL: 'getAdvertiserDetail',
  UNKNOWN: 'unknown',
};

export const MSG_BEFORE_FETCH = 'Fetch started';
export const MSG_AFTER_FETCH = 'Fetch succeeded';
export const MSG_FETCH_FAILED = 'Fetch failed';
export const MSG_EXCEPTION = 'Exception occurred';
